import { memo, useMemo } from 'react';

import dotize from 'dotize';
import { useTranslation } from 'react-i18next';

import { useConversationContext } from '@/hooks/useConversationContext';
import { customInputValueRender } from '@/modules/tryIt/components/VariablesSection/helper';

import { ContextVariableInput } from '../ContextVariable/ContextVariableInput';

export const ContextVariablesPanel = memo(() => {
  const { t } = useTranslation();
  const { filteredContextVars } = useConversationContext();
  const contextEntries = useMemo<[string, unknown][]>(
    () => Object.entries(dotize.convert(filteredContextVars)),
    [filteredContextVars]
  );
  const renderedValues = useMemo(
    () =>
      new Map(
        contextEntries.map(([key, value]) => [key, dotize.convert(customInputValueRender(value))])
      ),
    [contextEntries]
  );
  const isContextEmpty = contextEntries.length === 0;

  return (
    <div className="flex flex-col gap-px p-2">
      {isContextEmpty && (
        <p className="text-sm leading-5 font-normal text-foreground-muted">
          {t('conversation.empty_states.no_context_variables')}
        </p>
      )}

      <ul className="flex flex-col gap-2">
        {contextEntries.map(([key]) => (
          <li key={key}>
            <ContextVariableInput label={key} value={renderedValues.get(key)} />
          </li>
        ))}
      </ul>
    </div>
  );
});

ContextVariablesPanel.displayName = 'ContextVariablesPanel';
